var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"section-header",attrs:{"id":_vm.anchor}},[_c('div',{staticClass:"section-header__left"},[_c('span',{staticClass:"section-header__badge"},[_c('span',{staticClass:"material-icons-outlined"},[_vm._v(_vm._s(_vm.icon))])]),_c('span',{staticClass:"section-header__title"},[_vm._v(_vm._s(_vm.title))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }